import { Color } from '@kite-js/theme-types';

const orange: Color = {
    50: '#FDEEE6',
    100: '#FCDFCF',
    200: '#F38141',
    300: '#C15222',
    400: '#C04500',
    500: '#772B00',
};

export default orange;
